export default "__VITE_ASSET__QE3s2DdT__"